import {Box, Center, HStack, Link, Spinner, Text} from '@chakra-ui/react';
import ImageViewer from './ImageViewer';
import File from './Icon/File';
import {split, takeRight} from 'lodash';
import {isImageExtension} from 'utils/mime';
import {useState} from 'react';
import AutoFetchImage from './AutoFetchImage';
import {signDocUrl_} from 'hooks/datahook/common';

export const FileViewer = (props) => {
    const {url, downloadable, openInNewTab} = props;
    const isImageUrl = isImageExtension(url);
    const [downloading, setDownloading] = useState(false);
    const [openView, setOpenView] = useState(false);
    const height = 300;
    const [openLoading, setOpenLoading] = useState(false);

    const onOpenFile = async () => {
        try {
            setOpenLoading(true);
            if (url && !isImageExtension(url)) {
                const {signedUrl} = await signDocUrl_({url});
                window.open(signedUrl || url, '_blank');
            }
            setOpenLoading(false);
        } catch (error) {
            setOpenLoading(false);
        }
    };
    return (
        <>
            {openLoading && (
                <Center
                    position={'fixed'}
                    width={'100vw'}
                    height={'100vh'}
                    left={0}
                    top={0}
                    zIndex={10}
                    backgroundColor={'rgba(0, 0, 0, 0.05)'}
                >
                    <Spinner
                        size={'xl'}
                        pos={'absolute'}
                        left={'50%'}
                        top={'50%'}
                        transform={'translate(-50%, -50%)'}
                    />
                </Center>
            )}
            {isImageUrl ? (
                <>
                    <Box
                        // rounded={'md'}
                        overflow={'hidden'}
                        onClick={() =>
                            openInNewTab
                                ? window.open(url, '_blank')
                                : setOpenView(true)
                        }
                    >
                        {/* <img src={url} style={{height: height, objectFit: 'contain'}} /> */}
                        <AutoFetchImage
                            initialUrl={url}
                            style={{height: height, objectFit: 'contain'}}
                        />
                    </Box>
                    <ImageViewer
                        images={[url]}
                        open={openView}
                        onClose={() => setOpenView(false)}
                    />
                </>
            ) : (
                <HStack
                    py={0}
                    alignItems={'center'}
                    justifyContent="space-between"
                >
                    <HStack alignItems={'center'} spacing={2}>
                        <File />
                        <Box
                            href={url}
                            noOfLines={1}
                            w={{base: '250px', md: '100%'}}
                            cursor={'pointer'}
                            _hover={{
                                textDecoration: 'underline',
                            }}
                            onClick={() => onOpenFile()}
                        >
                            <Text>{takeRight(split(url, '/'), 1)}</Text>
                        </Box>
                    </HStack>
                </HStack>
            )}
        </>
    );
};
